<template>
<div id="box-container" :class="{isHope: title ==='Hope'}">
    <h2 class="header" :class="{lastStand: isLastStand, notLastStand: !isLastStand}">{{title}}</h2>
    <div id="box"  :class="{lastStand: isLastStand, notLastStand: !isLastStand}">
       <RandDice v-for="(roll, index) in noOfDice"
       :isLastStand="isLastStand"
       :rollValue="0"
       :key="roll+index"
       ref="DiceComponents"
       :isThem="isThem"
       /> 

    </div>
    <button :disabled="rollTimeout" id="rollButton" class="my-button" :class="{lastStand: isLastStand, notLastStand: !isLastStand}" :onmousedown="toggleShuffle" :onmouseup="rollDice">Roll</button>
    <div v-if="title === 'Us'" id="onesButtons">
        <button :disabled="rollTimeout" class="my-button ones-button" :class="{lastStand: isLastStand, notLastStand: !isLastStand}" @click="rerollOnes">Reroll 1s</button>
        <button :disabled="rollTimeout" class="my-button ones-button" :class="{lastStand: isLastStand, notLastStand: !isLastStand}" @click="removeOnes">Remove 1s</button>
    </div>
    <div v-else-if="title === 'Them'" id="onesButtons">
        <button :disabled="rollTimeout" class="my-button ones-button" :class="{lastStand: isLastStand, notLastStand: !isLastStand}" @click="returnDieUpToRemainingCandles">Return Die</button>
    </div>
</div>
</template>

<script>
import RandDice from './RandDice.vue'


export default {
  components: { RandDice },
    name:"DiceRoller",
    emits:["deleteDie"],
    props: {
        title: String,
        noOfDice: Number,
        isThem: Boolean,
        isLastStand: Boolean,
        
    },
    data () {
        return {
            rollTimeout: false,
            dieRemoved: 0,
            dieReturned: 0,
            shuffleInterval: "",
            diceRolls:[] // Send this to the State Storage
        }
    },
    methods:{
        rollDice(){
            this.$refs.DiceComponents.forEach(die => {
                die.toggleRolling(false);
            })
            this.rollTimeout = true;
            setTimeout(() => {
                this.rollTimeout = false;
                this.diceRolls=[];
                this.$refs.DiceComponents.forEach(die => {
                this.diceRolls.push(die.$data.value)
            })}, 4000)
        },
        toggleShuffle(){

                        this.$refs.DiceComponents.forEach(die => {
                            die.toggleRolling(true);
                            die.roll()
                        })

        },
        rerollOnes() {
            this.$refs.DiceComponents.forEach(die => die.rerollOne())
        },
        removeOnes() {
            
            this.$refs.DiceComponents.forEach(die => {
                let res = die.removeOne();
                if(res === true) this.dieRemoved++;
                console.log(this.dieRemoved)
            })
            this.$parent.bolsterThem(this.dieRemoved)
            this.dieRemoved = 0;
        },
        returnDieUpToRemainingCandles() {
            this.$parent.returnDice();
            console.log(this.$refs.DiceComponents)
        },
        resetDice(remainingDice) {
            this.$refs.DiceComponents.forEach((die, index) => {
                if(index <= remainingDice) die.returnDie()
                else die.disable()
                })

        }

    }
}
</script>
<style scoped>

  
    .header {
        font-size: 24pt;
        color: rgb(230, 230, 230)
    }

    #box-container{
        width: 300px;
    
    }
    #box {
        height: 70%;
        min-height: 110px;
        width: 300px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        flex-wrap: wrap;
        gap: 5px;
        padding: 5px;
        background-color: rgb(7,7,7);
       border-radius: 5px;

    }

    #box-container.isHope {
            width: 75px;
            flex-shrink: 1;
    }

    .isHope #box {
        height: 35%;
        min-height: 75px;
        width: 100%;
        padding: 0;

    }


    
    .notLastStand.header {
        border-width: 0px;
        box-shadow:none;
        background-color: rgba(0,0,0,0);
    }


    .lastStand.header {
        border-width: 0px;
        box-shadow: 0 0 0px 0px maroon;
        color: maroon;
        background-color: rgba(0,0,0,0);
        filter:drop-shadow(0px 0px 5px maroon);
    }

    .lastStand.my-button {
        color: white
    }

    #rollButton {
        height: 20%;
        width: inherit;
        margin-top: 10px;
                font-family: "SansCulottes";

    }

    #onesButtons {
        display: flex;
        margin-top: 5px;
        justify-content: stretch;
        width: inherit;
        height: 20%;
        gap: 5px;
    }

    .ones-button {
        flex:1;
        width: 50%;
        font-family: "SansCulottes";

    }

    .my-button:hover {
        cursor: pointer;
        opacity: 80%;
    }

    .my-button:active {
        opacity: 60%;
    }

    .my-button:disabled {
        opacity: 30%;
        cursor:not-allowed;
        pointer-events: none;
    }

</style>
